(function () {
    'use strict';

    angular
        .module('app')
        .controller('SuperSearchController', SuperSearchController);

    SuperSearchController.$inject = ['API', 'global', '$q'];

    function SuperSearchController(API, global, $q) {
        var vm = this;

        vm.loadingState = {
            search: false,
        };

        vm.isDesktop = global.isDesktop;
        vm.isSearchOpen = false;


        vm.searchData = {
            term: '',
            endpoints: [
                {
                    name: 'campaign',
                    endpoint: 'Campaign',
                    perPage: 10
                },
                {
                    name: 'contract',
                    endpoint: 'Contract',
                    perPage: 10,
                    expand: 'schools'
                },
                {
                    name: 'group',
                    endpoint: 'Group',
                    perPage: 10,
                    expand: 'school'
                },
                {
                    name: 'school',
                    endpoint: 'School',
                    perPage: 10,
                    expand: 'customer'
                },
                {
                    name: 'user',
                    endpoint: 'User',
                    perPage: 20,
                    expand: 'loginTeacher,loginStudent,loginThirdparty,groups,school'
                },
            ],
            data: {},
            showResults: false
        };
        vm.loadPromises = {
            campaign: null,
            contract: null,
            group: null,
            school: null,
            user: null,
        };
        vm.search = search;
        vm.openSearch = openSearch;
        vm.closeSearch = closeSearch;

        activate();

        function activate() {

        }

        function search() {

            if (vm.searchData.term.length > 1) {
                vm.loadingState.search = true;
                var promises = [];
                var searchTerm = parseSearchTerm(vm.searchData.term);

                vm.searchData.data = {};

                angular.forEach(vm.searchData.endpoints, function (endpoint) {
                    var searchObject = {
                        q: searchTerm,
                        'per-page': endpoint.perPage,
                    };

                    if (endpoint.expand) {
                        searchObject.expand = endpoint.expand;
                    }

                    var promise = API[endpoint.endpoint].search(searchObject).$promise;

                    promises.push(promise);

                    /**
                     * Save the latest promise for the resource.
                     */
                    vm.loadPromises[endpoint.name] = promise;

                    promise.then(function (data) {

                        /**
                         * When the request is done, check if the promise is the latest load promise
                         * before displaying the results.
                         */
                        if(vm.loadPromises[endpoint.name] === promise) {
                            vm.searchData.data[endpoint.name] = data.items;

                            if (vm.searchData.data[endpoint.name].length) {
                                vm.searchData.showResults = true;
                            }
                        }
                    }, function () {
                        vm.searchData.data[endpoint.name] = [];
                    });
                });

                $q.all(promises)
                    .then(function () {
                        vm.loadingState.search = false;
                        vm.searchData.showResults = true;
                    });
            } else {
                vm.searchData.data = {};
                vm.searchData.showResults = false;
            }
        }

        function parseSearchTerm(term) {
            var patterns = [
                {
                    regexp: /\b([a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)\b/,
                    matchIndex: 0
                }
            ];

            for (var i = 0; i < patterns.length; i++) {
                var matches = term.match(patterns[i].regexp);
                if (matches && matches[patterns[i].matchIndex]) {
                    return matches[patterns[i].matchIndex];
                }
            }

            var removeTheseFromSearch = ['\'', '"', '`', '´', '‘', '’', '“', '”'];
            angular.forEach(removeTheseFromSearch, function (quote) {
                term = term.replace(new RegExp(quote, 'g'), '');
            });

            return term;
        }

        function openSearch() {
            vm.isSearchOpen = true;
            setTimeout(function () {
                document.querySelector('#super-search')
                    .focus();
            }, 250);
        }

        function closeSearch() {
            vm.isSearchOpen = false;
        }
    }
})();